/* ============================================================
   LANDR — product page (gallery + variants), vanilla JS
   ============================================================ */
(function () {
  "use strict";

  document.querySelectorAll("[data-product]").forEach(function (root) {
    const variants = JSON.parse(root.querySelector("[data-variants]").textContent || "[]");
    const optionInputs = root.querySelectorAll("[data-option-index]");
    const idInput = root.querySelector("[data-variant-id]");
    const priceEl = root.querySelector("[data-price]");
    const addBtn = root.querySelector("[data-add-btn]");
    const moneyFormat = root.getAttribute("data-money-format") || "{{amount}}";

    function formatMoney(cents) {
      const placeholder = /\{\{\s*(\w+)\s*\}\}/;
      function withDelimiters(number, precision, thousands, decimal) {
        if (isNaN(number) || number == null) return "0";
        number = (number / 100).toFixed(precision);
        const parts = number.split(".");
        const intPart = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
        return intPart + (parts[1] ? decimal + parts[1] : "");
      }
      const token = (moneyFormat.match(placeholder) || [])[1] || "amount";
      let value;
      switch (token) {
        case "amount_no_decimals": value = withDelimiters(cents, 0, ",", ""); break;
        case "amount_with_comma_separator": value = withDelimiters(cents, 2, ".", ","); break;
        case "amount_no_decimals_with_comma_separator": value = withDelimiters(cents, 0, ".", ""); break;
        case "amount_with_apostrophe_separator": value = withDelimiters(cents, 2, "'", "."); break;
        case "amount_with_space_separator": value = withDelimiters(cents, 2, " ", ","); break;
        case "amount_no_decimals_with_space_separator": value = withDelimiters(cents, 0, " ", ""); break;
        default: value = withDelimiters(cents, 2, ",", "."); break;
      }
      return moneyFormat.replace(placeholder, value);
    }

    function selectedOptions() {
      const opts = [];
      optionInputs.forEach(function (group) {
        const checked = group.querySelector("input:checked");
        if (checked) opts[parseInt(group.getAttribute("data-option-index"), 10)] = checked.value;
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function update() {
      const opts = selectedOptions();
      const variant = findVariant(opts);
      // reflect chosen value labels
      optionInputs.forEach(function (group) {
        const label = group.querySelector("[data-option-value]");
        const checked = group.querySelector("input:checked");
        if (label && checked) label.textContent = checked.value;
      });
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute("data-unavailable") || "Unavailable"; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) {
        const onSale = variant.compare_at_price > variant.price;
        let html = '<span class="price' + (onSale ? " price--on-sale" : "") + '">';
        html += '<span class="price__regular">' + formatMoney(variant.price) + "</span>";
        if (onSale) {
          html += '<span class="price__compare">' + formatMoney(variant.compare_at_price) + "</span>";
          const pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
          html += '<span class="price__save">Save ' + pct + "%</span>";
        }
        priceEl.innerHTML = html + "</span>";
      }
      if (addBtn) {
        if (variant.available) { addBtn.disabled = false; addBtn.textContent = addBtn.getAttribute("data-add") || "Add to cart"; }
        else { addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute("data-soldout") || "Sold out"; }
      }
      // swap to variant image if present
      if (variant.featured_media_id) {
        const target = root.querySelector('[data-media-id="' + variant.featured_media_id + '"]');
        if (target) target.click();
      }
    }

    optionInputs.forEach(function (group) {
      group.addEventListener("change", update);
    });
    update();
  });

  /* ---- gallery thumbnails ---- */
  document.querySelectorAll("[data-gallery]").forEach(function (gallery) {
    const main = gallery.querySelector("[data-main-img]");
    gallery.querySelectorAll("[data-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        const full = thumb.getAttribute("data-full");
        if (main && full) { main.src = full; main.setAttribute("alt", thumb.getAttribute("data-alt") || ""); }
        gallery.querySelectorAll("[data-thumb]").forEach((t) => t.classList.remove("is-active"));
        thumb.classList.add("is-active");
      });
    });
  });
})();
